
const Statistics = () => {
  return (
    <div className='flex gap-3 flex-wrap justify-center w-full mt-5 divide-x  divide-gray-400'>

      <div className=" px-6">
        <h1 className='font-extralight text-white text-4xl mb-1 tracking-wider'>300+</h1>
        <h2 className='text-white'>DUMMY NAME</h2>
      </div>

      <div className=" px-6">
        <h1 className='font-extralight text-white text-4xl mb-1 tracking-wider'>340M+</h1>
        <h2 className='text-white'>DUMMY NAME</h2>
      </div>

      <div className=" px-6">
        <h1 className='font-extralight text-white text-4xl mb-1 tracking-wider'>$0.412</h1>
        <h2 className='text-white'>DUMMY NAME</h2>
      </div>

      <div className=" px-6">
        <h1 className='font-extralight text-white text-4xl mb-1 tracking-wider'>89%</h1>
        <h2 className='text-white'>DUMMY NAME</h2>
      </div>

      <div className=" px-6">
        <h1 className='font-extralight text-white text-4xl mb-1 tracking-wider'>300+</h1>
        <h2 className='text-white'>DUMMY NAME</h2>
      </div>
      
    </div>
  )
}

export default Statistics
